import { useSelector } from 'react-redux';

function PollAnswerOptions(props) {
    const isMobileView = useSelector(state => state.data.isMobileView);
    const threeColumns = props.answerOptions.length > 4;
    const pollHasImages = props.answerOptions && props.answerOptions.length > 0 &&
        props.answerOptions[0] && props.answerOptions[0].image_url;
    const pollClasses = `modal-options${!pollHasImages ? ' no-images' : props.rectangularImgs ?
        ' rectangular-img-options' : threeColumns && !isMobileView ? ' three-col' : ' two-col'}`;

    return ( 
        <div className={pollClasses}>
            { props.answerOptions.map((data, index) =>
                <div className="modal-answer-option" key={index}>
                    <div className="modal-answer-option-input">
                        <input type="radio" name="option" id={`option_${index}`} value={data.id}
                            className="modal-radio" onChange={() => props.handleSelection(data.id)} />
                        <label className="modal-answer-option-lbl" htmlFor={`option_${index}`}>
                            {data.value}
                        </label>
                    </div>
                    { pollHasImages &&
                        <label htmlFor={`option_${index}`}>
                        { props.rectangularImgs ?
                            <img src={data.image_url} alt={data.value} />
                        :
                            <div className="modal-answer-option-img" style={{ backgroundImage: `url("${data.image_url}")` }}
                            alt={data.value}></div>
                        }
                        </label>
                    }
                </div>
            )}
        </div>
    );
}

export default PollAnswerOptions;
